import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

const LoginUser = async (params) => {
    return await HTTP_CLIENT.post(Endpiont.auth.login, params);
};
const registerUser=async(params)=>{
    return await HTTP_CLIENT.post(Endpiont.auth.register, params);
}
const getAllUser = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.getUsers.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllUserQuery = (filter) => {
    return useQuery(['registeredUser',filter], () => getAllUser(filter));
};
const deleteUser = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.deleteUser.deletUse + id);
};

const LoginMutation = () => {
    return useMutation(LoginUser, {
        onSuccess: (data) => {},
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Server Error');
        }
    });
};
const RegisterMutation=()=>{
    const queryClient = useQueryClient();
    return useMutation(registerUser, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('registeredUser');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Server Error');
        }
    });
}
const DeleteUserMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteUser, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('User');
            toastMessage('success', 'User Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// const GetAllMutation=()=>{
//     return useMutation(allUsers, {
//         onSuccess: (data) => {},
//         onError: (error) => {
//             const desc = error?.response?.data?.desc;
//             toastMessage('error', desc || 'Server Error');
//         }
//     });
// }
// -----------------Forgot User
const ForgotUser = async (params) => {
    return await HTTP_CLIENT.post(Endpiont.auth.forgot, params);
};
const ForgotUserMutation = () => {
    return useMutation(ForgotUser,{
        onSuccess: (data) => {},
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Server Error');
        }
    });
};
// // -----------------Reset User Password
// const ResetUser = async (params) => {
//     return await HTTP_CLIENT.post(Endpiont.auth.reset, params);
// };
// const ResetUserPasswordMutation = () => {
//     return useMutation(ResetUser);
// };
// // -----------------Verify User
// const VerifyUser = async (params) => {
//     return await HTTP_CLIENT.post(Endpiont.auth.otp, params);
// };
// const VerifyUserMutation = () => {
//     return useMutation(VerifyUser);
// };
// // -----------------Verify Token
// const VerifyToken = async (params) => {
//     return await HTTP_CLIENT.post(Endpiont.auth.verifyToken, params);
// };
// const VerifyTokenMutation = () => {
//     return useMutation(VerifyToken);
// };
const updateUser = async ({ id, data }) => {
    return await HTTP_CLIENT.put(Endpiont.getUsers.list + '/update/' + id, data);
};

const UpdateUserMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateUser, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('registeredUser');
            toastMessage('success', 'User Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            toastMessage('error', desc || 'Server Error');
        }
    });
};

export { LoginMutation, RegisterMutation, GetAllUserQuery, ForgotUserMutation, DeleteUserMutation, UpdateUserMutation };
